import onReady from '../utils/onReady';
import * as ClassList from '../utils/classList';
import * as Events from '../utils/events';
import hoverintent from 'hoverintent';


/**
 * Boilerplate class demonstrating basic construction.
 * You can expand from here, or find verbose examples in example.js.
 *
 * @param {HTMLElement} container
 * @constructor
 */
class Megamenu {

    /**
     * The constructor is fired once the class is instantiated.
     *
     * @param {HTMLElement} container
     */
    constructor(container) {
        // Run initializing code once the DOM is ready.
        onReady(() => this.init(container));

        // You can put other initializer-code here if it isn't dependent on the DOM in any way.
    }

    addEvents() {
        if (this.dom.searchButton !== null) {
            Events.addEvent(this.dom.searchButton, "click", () => {
                // this.dom.overlayInput.select();

                // Reverse iterate through the list of main nav links
                for (let i = this.listItems.length - 1; i >= 0; i -= 1 ) {
                    setTimeout( () => {
                        // Each 50ms call toggleListItemClass
                        this.toggleListItemClass(this.listItems[i], i);
                    }, (300 - (50*i)));
                }
            });
        }

        if (this.dom.closeOverlayButton !== null) {
            Events.addEvent(this.dom.closeOverlayButton, "click", () => {
                // iterate through the list of main nav links
                for (let i = 0; i < this.listItems.length; i += 1 ) {
                    setTimeout( () => {
                        // Each 50ms call toggleListItemClass
                        this.toggleListItemClass(this.listItems[i], i);
                    }, 50*i);
                }
            });
        }

    }

    toggleListItemClass(element, index) {
        ClassList.toggle(element, "searchoverlayed");

        // After all the classes has been added to the list items, searchOverlay gets activated
        if (index === 0) {
            ClassList.toggle(this.dom.searchOverlay, "searchoverlay--active");

            if (ClassList.contains(this.dom.searchOverlay, "searchoverlay--active")) {
                this.dom.overlayInput.focus();
            }
        }
    }

    /**
     * The actual initialization function, fired once the DOM is ready.
     *
     * @param {HTMLElement} container
     */
    init(container) {

        this.dom = {
            container // ES6 allows this syntax instead of writing "container: container"
        };

        this.dom.searchOverlay = this.dom.container.querySelector(".searchoverlay");
        this.dom.searchButton = this.dom.container.querySelector(".mymenu__search");
        this.dom.closeOverlayButton = this.dom.container.querySelector(".searchoverlay") ? this.dom.searchOverlay.querySelector(".searchoverlay__closeButton") : null;
        this.dom.overlayInput = this.dom.container.querySelector(".searchoverlay") ? this.dom.searchOverlay.querySelector("input") : null;
        this.listItems = this.dom.container.querySelectorAll(".navigation__primary-link");
        this.navigationListItems = this.dom.container.querySelectorAll(".navigation__link");
		this.dom.primaryNavigation = this.dom.container.querySelector(".navigation__primary-main");
        this.dom.subNavigation = this.dom.container.querySelector(".navigation__primary-megamenu");
        this.dom.sublevelTriggers = this.dom.container.querySelectorAll(".sub-nav-toggle");

        this.addEvents();

        let opt = {
            interval: 50,
            sensitivity: 5,
            timeout: 200,
        };

        [].forEach.call(this.dom.sublevelTriggers, (button, idx) => {
            const parentListitem = button.parentNode.parentNode;
            const buttonIcon = button.querySelector(".icon");

            Events.addEvent(button, "click", () => {
                // handle button state
                const open = JSON.parse(button.getAttribute("aria-expanded"));
                button.setAttribute("aria-expanded", !open);
                ClassList.toggle(buttonIcon, "icon--deg90");

                // handle button text label
                if (!open) {
                    parentListitem.classList.add('navigation__link--active');
                } else {
                    parentListitem.classList.remove('navigation__link--active');
                }

                // handle sub level menu
                const hidden = JSON.parse(this.dom.subNavigation.getAttribute("aria-hidden"));
                this.dom.subNavigation.setAttribute("aria-expanded", !open);
                this.dom.subNavigation.setAttribute("aria-hidden", !hidden);
                this.dom.subNavigation.hidden = !hidden;
            });
        });

        [].forEach.call(this.navigationListItems, (x, idx) => {
			const navigationLink = x.querySelector("a");

            let hoverIntent = hoverintent(x,
                function() {
                    x.classList.add('navigation__link--active');
                },
                function() {
                    x.classList.remove('navigation__link--active');
                }
            ).options(opt);
        });
    }
}

export default Megamenu;
